/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editnormalizehint2Inputs */

const en_editnormalizehint2 = /** @type {(inputs: Editnormalizehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-levels is applied when you save (no live preview).`)
};

const de_editnormalizehint2 = /** @type {(inputs: Editnormalizehint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-Korrektur wird beim Speichern angewendet (keine Live-Vorschau).`)
};

/**
* | output |
* | --- |
* | "Auto-levels is applied when you save (no live preview)." |
*
* @param {Editnormalizehint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editnormalizehint2 = /** @type {((inputs?: Editnormalizehint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editnormalizehint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editnormalizehint2(inputs)
	return de_editnormalizehint2(inputs)
});
export { editnormalizehint2 as "editNormalizeHint" }